export const TIMERS = {
  REQUEST_TIMEOUT: 5000,
  RESIZE_DEBOUNCE: 100,
  SEARCH_DEBOUNCE: 300,
};
